/* eslint-disable camelcase */
import React from 'react';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import List from 'components/List';
import Modal from 'components/Modal';
import { Button, Clearfix, Col, Row } from 'react-bootstrap';
import moment from 'moment';
import { connect } from 'react-redux';
import ListItems from 'components/layout/subscriptions/ListItems';
import ListCompanyAndClient from 'components/layout/subscriptions/ListCompanyAndClient';
import ListCompany from 'components/layout/subscriptions/ListCompany';
// import Loader from 'components/layout/Loader';
import { editSubscriptionPriceR } from 'actions/SubscriptionPricesActions';
import { getTimezoneFromState } from 'js/helpers/intl';
import FormInput from 'components/forms/FormInput';
import FormAutocomplete from 'components/forms/FormAutocomplete';
import DateTimePicker from 'components/forms/DateTimePicker';
import FormSwitchery from 'components/forms/FormSwitchery';
import {
  getAvailableDateRange,
  getDateObject,
  getDateObjectFromDate,
  getPeriodStartEnd,
  resetDayTime,
} from 'helpers/subscriptions';
import IntlDateTime from 'components/layout/IntlDateTime';
// import FormLangInput from '../../forms/FormLangInput';
// import FormLangRichEditor from '../../forms/FormLangRichEditor';

// Subscription types
const TYPE_ITEM = 'item';
const TYPE_CLIENT = 'client';
const TYPE_CLIENT_ITEM = 'clientItem';
const TYPE_COMPANY = 'company';

class ClientSubscriptionEdit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      billingTarget: '',
      billingTargetClient: null,
      fee: 0,
      starting_fee: 0,
      newDateTime: moment(Date.now()),
      newDateTimeUntil: null,
      status: true,
      cancelAtPeriodEnd: false,
      type: '',
      items: [],
      clients: [],
      companies: [],
      companiesAndClients: [],
      showClients: false,
      showCompanies: false,
      showItems: false,
      showCompaniesAndClients: false,
      initialItems: [],
      initialClients: [],
      initialCompanies: [],
      initialCompaniesAndClients: [], // clientItem
      basicAbo: '',
      subscriptionPrice: null,
      subscriptionId: '',
      // id: '',
    };
  }

  componentDidUpdate = prevProps => {
    const { subscriptionPriceId, subscriptionPricesList } = this.props;
    const {
      data: { list },
    } = subscriptionPricesList;

    const isIdChanged = prevProps.subscriptionPriceId !== subscriptionPriceId;
    if (!isIdChanged) {
      return;
    }

    const subscriptionPrice = list.find(({ id }) => id === subscriptionPriceId);
    if (!subscriptionPrice) {
      console.error(this.constructor.name + ' subscriptionPrice not found by id ' + subscriptionPriceId);

      return;
    }

    const {
      fee,
      starting_fee,
      period_start,
      period_end,
      is_active,
      cancel_at,
      // target_type,
      subscription,
      client,
      item,
      billing_target,
      billingTarget,
      cancelAtPeriodEnd,
    } = subscriptionPrice;

    const target = billing_target || billingTarget;
    const { id: subscriptionId, type, name } = subscription;

    const newState = {
      fee,
      starting_fee,
      newDateTime: period_start,
      newDateTimeUntil: period_end,
      startDateRange: getAvailableDateRange(
        null,
        null,
        true,
        period_start,
        period_end,
        subscription,
        cancelAtPeriodEnd,
      ),
      endDateRange: getAvailableDateRange(null, null, false, period_end, period_end, subscription, cancelAtPeriodEnd),
      status: is_active,
      cancelAtPeriodEnd: cancel_at,
      type,
      subscriptionPrice,
      subscriptionId,
      billingTarget: target?.username ?? target,
      billingTargetClient: target?.username ? target : null,
      basicAbo: name,
      isActive: is_active,
      initialClients: type === TYPE_CLIENT ? [client] : [],
      initialCompaniesAndClients: type === TYPE_CLIENT_ITEM ? [client] : [],
      initialCompanies: type === TYPE_COMPANY ? [client] : [],
      initialItems: [item],
      ...this.showHide(type),
    };

    this.setState(newState);
  };

  pushOrDelete = (data, value) => {
    if (data.includes(value)) {
      return data.filter(v => v !== value);
    }

    return [...data, value];
  };

  getCompaniesAndClients1 = value => {
    const { clients } = this.state;
    const _clients = this.pushOrDelete(clients, value);
    this.setState({ clients: _clients });
  };

  getCompanies = value => {
    const { companies } = this.state;
    const _companies = this.pushOrDelete(companies, value);
    this.setState({ companies: _companies });
  };

  getItems = value => {
    const { items } = this.state;
    const _items = this.pushOrDelete(items, value);
    this.setState({ items: _items });
  };

  getCompaniesAndClients2 = value => {
    const { companiesAndClients } = this.state;
    const _companiesAndClients = this.pushOrDelete(companiesAndClients, value);
    this.setState({ companiesAndClients: _companiesAndClients });
  };

  removeData = (name, value) => {
    const map = {
      sub_co_and_cl1: 'clients',
      sub_company: 'companies',
      sub_co_and_cl2: 'companiesAndClients',
      sub_item: 'items',
    };

    const propName = map[name];
    if (!propName) {
      return;
    }

    const { [propName]: stateValue } = this.state;
    this.setState({ [propName]: stateValue.filter(v => v !== value) });
  };

  findSubscriptionType = subscriptionId => {
    const { subscriptionsList } = this.props;
    const {
      data: { list: srcList },
    } = subscriptionsList;

    const subscription = srcList.find(({ id: srcId }) => srcId === subscriptionId);
    if (!subscription) {
      console.error(
        this.constructor.name,
        'findSubscriptionType NOT FOUND',
        subscriptionId,
        srcList.map(({ id }) => id)
      );
      return;
    }

    const { type } = subscription;

    return type;
  };

  // setSubscriptionType = (name, value) => {
  //   const { subscriptionsList } = this.props;
  //   const {
  //     data: { list: srcList },
  //   } = subscriptionsList;
  //
  //   const subscription = srcList.find(({ id }) => id === value);
  //   if (!subscription) {
  //     return;
  //   }
  //   const { id, type, fee, starting_fee, period_start, period_end } = subscription;
  //   const update = {
  //     type,
  //     subscriptionId: id,
  //     fee,
  //     starting_fee,
  //     newDateTime: period_start,
  //     newDateTimeUntil: period_end,
  //     startDateRange: getAvailableDateRange(true, subscription),
  //     endDateRange: getAvailableDateRange(false, subscription),
  //   };

  //   const showHideSettings = this.showHide(type);
  //
  //   this.setState({ ...update, ...showHideSettings });
  // };

  showHide = type => {
    const { type: previousType } = this.state;

    const newState = {
      showClients: false,
      showCompanies: false,
      showItems: false,
      showCompaniesAndClients: false,
    };

    const propMap = {
      [TYPE_ITEM]: 'showItems',
      [TYPE_CLIENT]: 'showClients',
      [TYPE_COMPANY]: 'showCompanies',
      [TYPE_CLIENT_ITEM]: 'showCompaniesAndClients',
    };

    if (type in propMap) {
      newState[propMap[type]] = true;
    }

    if (previousType === type) {
      return newState;
    }

    // type has changed
    return { ...newState, clients: [], items: [], companies: [], companiesAndClients: [] };
  };

  // setBillingTarget = (_, client) => {
  //   const { username } = client;
  //   this.setState({ billingTarget: username, billingTargetClient: client });
  // };

  setNewDateTime = (name, value) => {
    let { newDateTimeUntil } = this.state;
    const { subscriptionId, newDateTime, cancelAtPeriodEnd } = this.state;
    const { subscriptionsList } = this.props;
    const subscription = subscriptionsList?.data?.list?.find(({ id }) => id === subscriptionId);

    if (newDateTime < new Date()) {
      return;
    }
    if (!cancelAtPeriodEnd) {
      const date = getPeriodStartEnd(
        subscription?.period_start,
        subscription?.period_end,
        subscription?.billing_cycle,
        value
      );
      newDateTimeUntil = date.endDate;
    }

    this.setState({
      newDateTime: value,
      newDateTimeUntil,
      startDateRange: getAvailableDateRange(
        subscriptionId,
        subscriptionsList,
        true,
        value,
        newDateTimeUntil,
        cancelAtPeriodEnd,
      ),
      endDateRange: getAvailableDateRange(
        subscriptionId,
        subscriptionsList,
        false,
        value,
        newDateTimeUntil,
        cancelAtPeriodEnd,
      ),
    });
  };

  setNewDateTimeUntil = (_, newDateTimeUntil) => {
    const { subscriptionId, newDateTime, cancelAtPeriodEnd } = this.state;
    const { subscriptionsList } = this.props;
    this.setState({
      newDateTimeUntil,
      cancelAtPeriodEnd: true,
      startDateRange: getAvailableDateRange(
        subscriptionId,
        subscriptionsList,
        true,
        newDateTime,
        newDateTimeUntil,
        cancelAtPeriodEnd,
      ),
      endDateRange: getAvailableDateRange(
        subscriptionId,
        subscriptionsList,
        false,
        newDateTime,
        newDateTimeUntil,
        cancelAtPeriodEnd,
      ),
    });
  };

  changeCancelAtPeriodEnd = (_, cancelAtPeriodEnd) => {
    let { subscriptionId, newDateTime, newDateTimeUntil } = this.state;
    const { subscriptionsList } = this.props;

    let subscription = subscriptionsList?.data?.list?.find(({ id }) => id === subscriptionId);

    if (!cancelAtPeriodEnd) {
      const date = getPeriodStartEnd(
        subscription?.period_start,
        subscription?.period_end,
        subscription?.billing_cycle,
        newDateTime,
      );
      newDateTimeUntil = date.endDate;
    }

    this.setState({
      newDateTime,
      newDateTimeUntil,
      cancelAtPeriodEnd,
      startDateRange: getAvailableDateRange(
        subscriptionId,
        subscriptionsList,
        true,
        newDateTime,
        newDateTimeUntil,
        subscription,
        cancelAtPeriodEnd,
      ),
      endDateRange: getAvailableDateRange(
        subscriptionId,
        subscriptionsList,
        false,
        newDateTime,
        newDateTimeUntil,
        subscription,
        cancelAtPeriodEnd,
      ),
    });
  };

  editClientSubscription = () => {
    const {
      newDateTime,
      newDateTimeUntil,
      newSubscription,
      // title,
      // description,
      fee,
      status,
      cancelAtPeriodEnd,
      subscriptionId,
      starting_fee,
      type,
      // id,
      clients,
      companies,
      companiesAndClients,
      items,
      billingTarget,
    } = this.state;
    const { editSubscriptionPriceR, closeEditClientSubscription, subscriptionPriceId } = this.props;

    const data = {
      subscription: subscriptionId,
      type,
      name: newSubscription,
      clients: [...clients],
      companys: [...companies],
      clientItems: [...companiesAndClients],
      items: [...items],
      periodStart: newDateTime,
      periodEnd: newDateTimeUntil,
      starting_fee,
      fee,
      isActive: status,
      billingTarget,
      cancelAtPeriodEnd: cancelAtPeriodEnd,
    };

    editSubscriptionPriceR(subscriptionPriceId, data);
    closeEditClientSubscription();
  };

  getBillingTargetOption = () => {
    const { billingTarget, billingTargetClient } = this.state;

    if (billingTargetClient) {
      const { username, profile, id } = billingTargetClient;

      const option = { value: username, label: username, username, profile, id };
      if (profile) {
        const { company, first_name, last_name, stree, city } = profile;
        option.label = [company, first_name, last_name, stree, city].join(' ');
      }

      return option;
    }

    if (billingTarget) {
      const profile = {};
      const option = {
        value: billingTarget,
        label: billingTarget,
        username: billingTarget,
        profile,
        id: billingTarget,
      };

      return option;
    }
  };

  render() {
    const { intl, show, close, appIntl, defaultTimezone, subscriptionsList } = this.props;
    const {
      basicAbo,
      subscriptionPrice,
      // title,
      // description,
      newSubscription,
      starting_fee,
      fee,
      // status,
      newDateTime,
      newDateTimeUntil,
      startDateRange,
      endDateRange,
      type,
      items,
      clients,
      companies,
      showItems,
      showClients,
      showCompanies,
      showCompaniesAndClients,
      initialItems,
      initialClients,
      initialCompanies,
      initialCompaniesAndClients,
      cancelAtPeriodEnd,
      isActive,
    } = this.state;
    const { messages } = intl;
    const {
      data: { list: srcSubscriptionsList },
    } = subscriptionsList;
    const subscriptionId = subscriptionPrice?.subscription.id;

    const isTargetSelected = [clients, companies, items].some(arr => arr?.length > 0);
    const isRequiredNotNull = [newSubscription, type, fee].every(value => value !== null);
    const isEditEnabled = isTargetSelected && isRequiredNotNull;

    const option = this.getBillingTargetOption();
    const billingTargetKey = option ? [option.id, option.value, option.label].join('-') : '-';

    let startDate = resetDayTime(new Date(newDateTime));
    let currentDate = resetDayTime(new Date());

    let isNewDateTimeChangable = !isActive || (startDate >= currentDate && isActive);

    return (
      <>
        <List
          noRender
          listName="subscriptions"
          url="/api/subscriptions/list/subscriptions.json"
          list={subscriptionsList}
        />
        <Modal show={show} onHide={close} bsSize="lg" enforceFocus={false}>
          <Modal.Header closeButton>
            <Modal.Title>{messages.edit_subscription}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md={12}>
                <div className="form-group form-group-default p-t-10 p-b-10 addSubscriptionForm">
                  {/*
                  <FormInput
                    type="text"
                    label={messages.subscription_name}
                    name="subscription_name"
                    onChange={(name, value) => this.setState({ newSubscription: value })}
                    value={newSubscription}
                    disabled=""
                  />

                    <FormLangInput
                      label={messages.subscription_title}
                      name="title"
                      value={title}
                      onChange={(name, value) => this.setState({ title: value })}
                    />
                    <FormLangRichEditor
                      name="description"
                      label={messages.subscription_description}
                      value={description}
                      onChange={(name, value) => this.setState({ description: value })}
                    />
                  */}
                  <FormAutocomplete
                    // onChange={this.setSubscriptionType}
                    label={messages.subscription_basic + ' - ' + basicAbo}
                    name="type"
                    value={subscriptionId}
                    key={subscriptionId}
                    options={srcSubscriptionsList.map(({ name, id }) => ({ label: name, value: id }))}
                    disabled=""
                  />
                  <div className="subcriptionLists">
                    {showItems && (
                      <ListItems
                        key="items"
                        getItems={this.getItems}
                        // removeData={this.removeData}
                        dataInitialValues={{ name: TYPE_ITEM, value: initialItems }}
                        appIntl={appIntl}
                        disabled=""
                        filter={{ type: 'itemWebsite' }}
                      />
                    )}
                    {showClients && (
                      <>
                        <ListCompanyAndClient
                          key="clients"
                          getCompaniesAndClients1={this.getCompaniesAndClients1}
                          // removeData={this.removeData}
                          dataInitialValues={{ name: TYPE_CLIENT, value: initialClients }}
                          paramName="sub_co_and_cl1"
                          disabled=""
                        />
                      </>
                    )}
                    {showCompanies && (
                      <ListCompany
                        key="companies"
                        getCompanies={this.getCompanies}
                        // removeData={this.removeData}
                        dataInitialValues={{ name: TYPE_COMPANY, value: initialCompanies }}
                        paramName="sub_company"
                        disabled=""
                      />
                    )}
                    {showCompaniesAndClients && (
                      <>
                        <ListCompanyAndClient
                          key="clientsAndCompanies"
                          getCompaniesAndClients2={this.getCompaniesAndClients2}
                          // removeData={this.removeData}
                          paramName="sub_co_and_cl2"
                          dataInitialValues={{ name: TYPE_CLIENT_ITEM, value: initialCompaniesAndClients }}
                          disabled=""
                        />
                      </>
                    )}
                  </div>
                  <FormAutocomplete
                    label={messages.billing_target}
                    name="billingTarget"
                    autocompleteType="client"
                    // onChange={this.setBillingTarget}
                    value={this.getBillingTargetOption()}
                    urlFilters={{ depth: 'shallow' }}
                    returnValueObject
                    clearable
                    key={billingTargetKey}
                    disabled=""
                  />
                  <FormInput
                    type="number"
                    label={messages.subscription_startingFee}
                    name="starting_fee"
                    onChange={(name, value) => this.setState({ starting_fee: value })}
                    value={starting_fee}
                    disabled=""
                  />
                  <FormInput
                    type="number"
                    label={messages.subscription_fee}
                    name="fee"
                    onChange={(name, value) => this.setState({ fee: value })}
                    value={fee}
                    disabled=""
                  />

                  {isNewDateTimeChangable ? (
                    <DateTimePicker
                      value={newDateTime}
                      label={messages.subscription_start}
                      locale={appIntl.locale}
                      minDate={startDateRange?.minDate}
                      maxDate={startDateRange?.maxDate}
                      displayTz={defaultTimezone}
                      onChange={this.setNewDateTime}
                    />
                  ) : (
                    <div className="form-group form-group-default">
                      <label>{messages.subscription_start}</label>
                      <div className="lh-25">
                        <Clearfix>
                          <span>
                            <IntlDateTime date={newDateTime} />
                          </span>
                        </Clearfix>
                      </div>
                    </div>
                  )}
                  {cancelAtPeriodEnd ? (
                    <DateTimePicker
                      value={newDateTimeUntil}
                      label={messages.subscription_end}
                      minDate={endDateRange?.minDate}
                      maxDate={endDateRange?.maxDate}
                      locale={appIntl.locale}
                      displayTz={defaultTimezone}
                      onChange={this.setNewDateTimeUntil}
                    />
                  ) : (
                    <div className="form-group form-group-default">
                      <label>{messages.subscription_end}</label>
                      <div className="lh-25">
                        <Clearfix>
                          <span>
                            <IntlDateTime date={newDateTimeUntil} />
                          </span>
                        </Clearfix>
                      </div>
                    </div>
                  )}

                  <div className="m-t-10">
                    <FormSwitchery
                      name="cancelAtPeriodEnd"
                      label={messages.period_status}
                      value
                      checked={!!cancelAtPeriodEnd}
                      onChange={this.changeCancelAtPeriodEnd}
                      disabled=""
                    />
                  </div>

                  <Button
                    onClick={() => this.editClientSubscription()}
                    disabled={!isEditEnabled}
                    bsStyle="primary"
                    className="pull-right"
                    title="create_subscription"
                  >
                    <span className="hidden-xs">{messages.save_subscription}</span>
                  </Button>
                </div>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    subscriptionPricesList: state.list.subscriptionPrices,
    subscriptionsList: state.list.subscriptions,
    defaultTimezone: getTimezoneFromState(state),
  };
};

const mapDispatchToProps = {
  editSubscriptionPriceR,
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ClientSubscriptionEdit)
  )
);
